import React from "react";
import locale from "../../locale";

const Nomination = (props) => {
	return (
		<article>
			<div className="nomination-count">{props.count}</div>
			<div className="nomination-title">{locale.getProperty(props, 'title')}</div>
			{/*<div className="nomination-icon">{props.icon}</div>*/}
		</article>
	);
};

class LayoutNominations extends React.Component
{
	render()
	{
		const {settings} = this.props;
		const {nominations} = settings;

		if (!settings) {
			return null;
		}

		return (
			<aside className="section-nominations" id="nominations">
				<h1>{locale.getProperty(settings, 'title')}</h1>
				<div className="landing-nav-section-text">
					{nominations.map((nomination, index) => <Nomination key={`nomination_${index}`} {...nomination} />)}
				</div>
			</aside>
		);
	}
}

export default LayoutNominations;
